import SelectProvider from './SelectProvider';

export default SelectProvider;
